import { Router } from "express";
import { db } from "@workspace/db";
import { activityEventsTable } from "@workspace/db";
import { eq, desc } from "drizzle-orm";
import { requireAuth, type AuthRequest } from "../lib/auth";

const router = Router();

router.get("/activity", requireAuth, async (req: AuthRequest, res, next) => {
  try {
    if (!req.companyId) return res.json([]);
    const limit = Math.min(Number(req.query.limit ?? 20), 100);
    const events = await db
      .select()
      .from(activityEventsTable)
      .where(eq(activityEventsTable.companyId, req.companyId))
      .orderBy(desc(activityEventsTable.createdAt))
      .limit(limit);
    res.json(events);
  } catch (err) {
    next(err);
  }
});

export default router;
